import { contacts } from "../../../pages-data/_V2/common/contacts"

export default {
	title: "Если нужно оптимизировать бизнес-процессы как можно быстрее",
	description:
		"Мы настроим систему под потребности бизнеса — для повышения среднего чека, снижения трат, защиты от краж.",
	phone: contacts.phone,
	ctaButtonText: "Заказать звонок",
}
